// Visible copy lives in i18n (src/i18n/locales/*). This file holds only
// structure: images, icons and stat values for the home page sections.

export type HomeStat = {
  value: string;
  suffix: string;
  labelKey: string;
};

export const homeData = {
  hero: {
    // Luxury Co-living Cronulla project photo — fills edge-to-edge, no side bars.
    image: "/portfolios/luxury-co-living-development-cronulla/cover.jpg",
    // Optional background video URL; empty string falls back to the image above.
    video: "",
  },
  about: {
    image1: "/images/about-img-1.jpg",
    image2: "/images/about-img-2.jpg",
  },
  // Accreditation stat counters (labels resolved via i18n labelKey).
  stats: [
    { value: "20", suffix: "+", labelKey: "stats.projects" },
  ] as HomeStat[],
  // Service cards — text from i18n `services.items`, icon by index (Font Awesome).
  services: [
    { icon: "fa-compass-drafting" },
    { icon: "fa-building" },
    { icon: "fa-list-check" },
    { icon: "fa-handshake" },
  ],
  // Why MGC pillars — text from i18n `whyMgc.items`, icon by index.
  whyMgc: [
    { icon: "fa-award" },
    { icon: "fa-helmet-safety" },
    { icon: "fa-clock" },
    { icon: "fa-clipboard-check" },
  ],
};
